export default __webpack_public_path__ + "5d88714eb28d6e10f8d7c351aea094ad.png";